/**
 * What the device is, read from the browser once per call. Plain functions,
 * not hooks: nothing here is React state.
 */

/** The operating system, as app links and app stores see it. */
export type DeviceOs = 'desktop' | 'ios' | 'android';

export function detectOs(): DeviceOs {
  if (typeof navigator === 'undefined') return 'desktop';

  const ua = navigator.userAgent;

  if (/Android/i.test(ua)) return 'android';

  if (/iPad|iPhone|iPod/.test(ua)) return 'ios';

  // iPad with desktop-class browsing (reports as Mac but has touch)
  if (/Mac/.test(ua) && navigator.maxTouchPoints > 2) return 'ios';

  return 'desktop';
}

/** A phone or a tablet: hosted Ronan uses its mobile layout. */
export function isMobileDevice(): boolean {
  return detectOs() !== 'desktop';
}

/**
 * A phone, as opposed to a tablet or computer. Embedded Ronan opens as a drawer on
 * phones only; tablets get the card with the QR code, like desktop.
 */
export function isPhone(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  return /iPhone|iPod/.test(ua) || (/Android/i.test(ua) && /Mobile/i.test(ua));
}
